import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const VeryHappyFace = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path id="Vector" d="M14.5832 13.1253H11.6665M23.3332 13.1253H20.4165M2.9165 17.5003C2.9165 25.5544 9.44568 32.0837 17.4998 32.0837C25.5539 32.0837 32.0832 25.5544 32.0832 17.5003C32.0832 9.44617 25.5539 2.91699 17.4998 2.91699C9.44568 2.91699 2.9165 9.44617 2.9165 17.5003ZM20.4165 18.9587H14.5832V23.3337C14.5832 24.3059 15.1665 26.2503 17.4998 26.2503C19.8332 26.2503 20.4165 24.3059 20.4165 23.3337V18.9587Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} viewBox="0 0 35 35" variant="outline">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { VeryHappyFace };